


import { ICustomerCreateModel } from "../models/customer/customer-create.model";
import { ICustomerCreateResponseModel } from "../models/customer/customer-create.response.model";
import { ICustomerCreateDtoModel } from "../models/customer/dto/customer-create-dto.model";
import { ICustomerCreateResponseDtoModel } from "../models/customer/dto/customer-create-dto.response.model";
import { IJcontrolCustomerCreationDtoModel } from "../models/legacy-info/jcontrol-customer-creation-dto.model";
import { IJcontrolCustomerCreationModel } from "../models/legacy-info/jcontrol-customer-creation.model";
import { IModelMapping } from "./generic/model.mapping";

export class CustomerCreateMapping implements IModelMapping<ICustomerCreateDtoModel, ICustomerCreateModel>  {
    toApplicationModel(model: ICustomerCreateDtoModel): ICustomerCreateModel {
        return { ...model } as ICustomerCreateModel;
    }
    toDtoModel(model: ICustomerCreateModel): ICustomerCreateDtoModel {
        return { ...model } as ICustomerCreateDtoModel;
    }
    toDtoModels(models: ICustomerCreateModel[]): ICustomerCreateDtoModel[] {
        return { ...models } as ICustomerCreateDtoModel[];
    }
    toApplicationModels(models: ICustomerCreateDtoModel[]): ICustomerCreateModel[] {
        return { ...models } as ICustomerCreateModel[];
    }

    toResponseApplicationModel(model: ICustomerCreateResponseDtoModel): ICustomerCreateResponseModel {
        return { ...model } as ICustomerCreateResponseModel;
    }

    toJcontrolCustomerCreateModel(model: IJcontrolCustomerCreationDtoModel): IJcontrolCustomerCreationModel {

        return {         
            ...model,
            managedBy: undefined, //clear this as it isn't being defined correctly and it will override managedByUsername if left in
            managedByUsername: model.managedByUsername,
        } as IJcontrolCustomerCreationModel;

    }

    toJcontrolCustomerCreateDtoModel(model: IJcontrolCustomerCreationModel): IJcontrolCustomerCreationDtoModel {
        return { ...model } as IJcontrolCustomerCreationDtoModel;
    }

}